import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { SectionCard, WhiteCard } from 'src/components';

import { BonusIcon, ExchangeIcon, SupportIcon } from 'src/assets';
import './benefits.scss';

export const Benefits = () => {
  const { t } = useTranslation('benefits');

  const items = [
    { icon: ExchangeIcon, title: t('exchangeTitle'), description: t('exchangeDescr') },
    { icon: SupportIcon, title: t('suppoertTitle'), description: t('suppoertDescr') },
    { icon: BonusIcon, title: t('bonusTitle'), description: t('bonusDescr') },
  ];

  const renderBenefitItem = useCallback((key, icon, title, description) => {
    return (
      <WhiteCard key={key}>
        <div className="benefits__item__title">
          <img src={icon} alt={icon} className="benefits__item__image" />
          <h4>{title}</h4>
        </div>
        {description}
      </WhiteCard>
    );
  }, []);

  return (
    <div className="benefits">
      <SectionCard title={t('title')}>
        {items.map((item, index) =>
          renderBenefitItem(index, item.icon, item.title, item.description),
        )}
      </SectionCard>
    </div>
  );
};
